import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import GroupBottomTypeArea from "./GroupBottomTypeArea/GroupBottomTypeArea";
import GroupHeaderSection from "./GroupHeaderSection/GroupHeaderSection";
import ChatsSection from "../../../Pages/Group/ChatsSection/ChatsSection";
import { FadeLoader } from "react-spinners";
import NoChats from "../../../Components/NoChats/NoChats";

export default function ChatingGroupSection({
  hasMoreMessage,
  setActiveSection,
  setShowProfileView,
  groupActiveChat,
  showAddMenu,
  setShowAddMenu,
  sendMessage,
  sendFilesInMessage,
  allMessages,
  setAllMessages,
  isMessageLoading,
  scrollfetchingData,
  getSecretKey,
  settings,
  chatConversationId,
  setAllGroups,
  socket,
}) {
  const chatContainerRef = useRef(null);
  const [loading, setLoading] = useState(false);
  const [isDecryptionLoading, setIsDecryptionLoading] = useState(false);

  useEffect(() => {
    setIsDecryptionLoading(true);
  }, [chatConversationId]);

  useEffect(() => {
    if (chatContainerRef.current) {
      const container = chatContainerRef.current;
      const isNearTop = Math.abs(container.scrollTop) < 500; // Consider "near top" as within 100px

      if (isNearTop) {
        container.scrollTop = 0;
      }
    }
  }, [allMessages.length]);

  useEffect(() => {
    const container = chatContainerRef.current;

    const handleScroll = async () => {
      if (!container || loading || !hasMoreMessage) return;
      const isAtBottom =
        Math.abs(
          container.scrollTop + container.scrollHeight - container.clientHeight
        ) < 1;
      if (isAtBottom) {
        setLoading(true);
        await scrollfetchingData();
        setLoading(false);
      }
    };

    if (container) {
      container.addEventListener("scroll", handleScroll);
    }

    return () => {
      if (container) {
        container.removeEventListener("scroll", handleScroll);
      }
    };
  }, [loading, scrollfetchingData]);

  const bgColor = useMemo(() => {
    return isMessageLoading ? `bg-[#F9F7FF] dark:bg-slate-900` : `bg-[${settings?.background}] dark:bg-slate-900`;
  }, [settings, isMessageLoading]);

  return (
    <div className="flex flex-col flex-1 h-full">
      {groupActiveChat ? (
        <>
          {groupActiveChat && (
            <GroupHeaderSection
              setShowProfileView={setShowProfileView}
              groupActiveChat={groupActiveChat}
              setActiveSection={setActiveSection}
            />
          )}

          <main
            className={`flex-1 ${showAddMenu ? "overflow-hidden" : "overflow-y-auto"
              } px-0 pb-0 flex flex-col-reverse ${bgColor} ${allMessages.length > 0 ? "pl-4 pb-4" : "px-0"
              }`}
            ref={chatContainerRef}
          >
            {!isMessageLoading && (
              <ChatsSection
                isDecryptionLoading={isDecryptionLoading}
                setIsDecryptionLoading={setIsDecryptionLoading}
                allMessages={allMessages}
                setAllMessages={setAllMessages}
                getSecretKey={getSecretKey}
                settings={settings}
                chatConversationId={chatConversationId}
                isMessageLoading={isMessageLoading}
                setAllGroups={setAllGroups}
                groupActiveChat={groupActiveChat}
                socket={socket}
              />
            )}
            {!isMessageLoading && allMessages.length === 0 && <NoChats />}
            {/* <div ref={bottomRef}></div> */}
            {loading && (
              <div className="text-center text-sm text-gray-400 py-2">
                Loading messages...
              </div>
            )}
          </main>

          {groupActiveChat && (
            <footer className="w-full min-h-[80px] bg-white dark:bg-slate-900 flex items-center justify-between border-b border-[#EBEBEB] dark:border-slate-700 text-black dark:text-white p-4 text-center">
              <GroupBottomTypeArea
                onScheduleClick={() => {
                  setActiveSection("schedule");
                  setShowProfileView(true);
                }}
                setShowAddMenu={setShowAddMenu}
                showAddMenu={showAddMenu}
                sendMessage={sendMessage}
                sendFilesInMessage={sendFilesInMessage}
                groupActiveChat={groupActiveChat}
              />
            </footer>
          )}
        </>
      ) : (
        <NoChats />
      )}
    </div>
  );
}
